<template>
    <div>
        <template v-if="pageLoading">
            <loading-spinner />
        </template>
        <template v-else>
            <x-container fluid app-width>
                <x-layout align-end mb-5>
                    <x-flex xs8>
                        <h1>Facility management</h1>
                    </x-flex>
                    <x-flex xs4 text-xs-right mb-2>
                        <x-btn class="ma-0" color="primary" large @click="addFacility">Add facility</x-btn>
                    </x-flex>
                </x-layout>

                <x-layout>
                    <x-flex>
                        <x-container class="summary-container">
                            <x-layout>
                                <x-flex>
                                    <x-data-table
                                        class="no-row-hover"
                                        :headers="headers"
                                        :items="formattedFacilities"
                                        :pagination.sync="pagination"
                                        hide-actions
                                    >
                                        <template v-slot:no-data>
                                            <p class="error-message text-xs-center">No facilities found</p>
                                        </template>

                                        <template v-slot:items="props">
                                            <td>
                                                {{ props.item.name }}
                                            </td>

                                            <td>
                                                {{ getStatus(props.item.status) }}
                                            </td>

                                            <td>
                                                {{ props.item.umr }}
                                            </td>

                                            <td>
                                                {{ props.item.brokerage | percent }}
                                            </td>

                                            <td>
                                                {{ props.item.insurer_count }}
                                            </td>

                                            <td>
                                                {{ props.item.client_name }}
                                            </td>

                                            <td>
                                                {{ props.item.producing_broker_name }}
                                            </td>

                                            <td>
                                                {{ props.item.captive_insurer_name }}
                                            </td>

                                            <td class="text-xs-center">
                                                <x-btn
                                                    class="ma-0"
                                                    color="tertiary"
                                                    icon
                                                    @click="editFacility(props.item.facility)"
                                                >
                                                    <x-icon>edit</x-icon>
                                                </x-btn>
                                            </td>
                                        </template>
                                    </x-data-table>
                                </x-flex>
                            </x-layout>

                            <x-layout mt-5 mb-5>
                                <x-flex xs12 text-xs-center>
                                    <x-pagination circle v-model="pagination.page" :length="pageCount" :total-visible="15" color="grey-1" />
                                </x-flex>
                            </x-layout>
                        </x-container>
                    </x-flex>
                </x-layout>
            </x-container>

            <x-dialog
                v-model="showFacilityForm"
                width="800"
                persistent
                content-class="overflow-scroll"
            >
                <facility-form
                    v-if="showFacilityForm && Object.keys(waitingPeriods).length > 0"
                    ref="form"
                    :facility="activeFacility"
                    :producing-brokers="producingBrokersList"
                    :clients="clients"
                    :insurers="insurers"
                    :captive-insurers="captiveInsurers"
                    :editing="editing"
                    :products="products"
                    :securities="securities"
                    @close="closeFacilityForm"
                    @submit="submitFacility"
                    :waitingPeriods="waitingPeriods"
                />
            </x-dialog>

            <x-dialog
                v-model="showFacilitySummary"
                width="800"
            >
                <facility-summary
                    v-if="showFacilitySummary"
                    :facility="activeFacility"
                    :summary="facilitySummaryDataListItems"
                    @close="closeSummary"
                />
            </x-dialog>

        </template>
    </div>
</template>

<script>
    import FacilityForm from '~/components/Broker/Facility/FacilityForm.vue';
    import FacilitySummary from '~/components/Broker/Facility/FacilitySummary.vue'
    import Modal from '~/components/Shared/UIComponents/Modal';
    import rules from '~/mixins/rules';
    import WaitingPeriodInterestOptions from '~/data/wpi_options.json';

    export default {
        name: 'FacilityManager',
        components: {
            FacilityForm,
            FacilitySummary,
            Modal
        },
        mixins: [rules],
        data() {
            return {
                pageLoading: true,
                facilities: [],
                companies: [],
                clients: [],
                products: [],
                securities: [],
                headers: [
                    {
                        text: 'Name',
                        value: 'name'
                    },
                    {
                        text: 'Status',
                        value: 'status'
                    },
                    {
                        text: 'UMR',
                        value: 'umr'
                    },
                    {
                        text: 'Brokerage',
                        value: 'brokerage'
                    },
                    {
                        text: 'Insurers',
                        value: 'insurer_count'
                    },
                    {
                        text: 'Client',
                        value: 'client_name'
                    },
                    {
                        text: 'Producing broker',
                        value: 'producing_broker_name'
                    },
                    {
                        text: 'Captive Insurer',
                        value: 'captive_insurer_name'
                    },
                    {
                        text: 'Actions',
                        align: 'center',
                        sortable: false
                    }
                ],
                pagination: {
                    totalItems: 0,
                    page: 1,
                    rowsPerPage: 10,
                    sortBy: 'name'
                },
                activeFacility: {
                    id: null,
                    insurer_ids: [],
                    security_ids: [],
                    product_ids: [],
                    waiting_period_values: [],
                    waiting_period_interest: WaitingPeriodInterestOptions[0].value,
                    do_not_display_sof: false,
                    status: 1,
                },
                editing: false,
                showFacilityForm: false,
                showFacilitySummary: false,
                naCompany: { id: null,
name: 'N/A' },
            }
        },
        computed: {
            formattedFacilities() {
                return this.facilities.map(facility => {
                    return {
                        facility: facility,
                        name: facility.name,
                        status: facility.status,
                        umr: facility.UMR,
                        brokerage: facility.brokerage,
                        insurer_count: this.getFacilityInsurers(facility).length,
                        client_name: this.getFacilityClient(facility).name,
                        producing_broker_name: this.getFacilityProducingBroker(facility).name,
                        captive_insurer_name: this.getFacilityCaptiveInsurer(facility).name,
                    }
                });
            },
            producingBrokersList () {
                return [this.naCompany, ...this.producingBrokers];
            },
            pageCount() {
                if (!this.pagination.rowsPerPage || !this.pagination.totalItems) {
                    return 0;
                }

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
            },
            facilitySummaryDataListItems() {
                return [
                    {
                        text: 'Name',
                        value: this.activeFacility.name
                    },
                    {
                        text: 'Status',
                        value: this.getStatus(this.activeFacility.status)
                    },
                    {
                        text: 'Brokerage',
                        value: this.activeFacility.brokerage
                    },
                    {
                        text: 'UMR',
                        value: this.activeFacility.UMR
                    },
                    {
                        text: 'Waiting period interest',
                        value: this.getWaitingPeriodInterestName
                    },
                    {
                        text: 'Premium payment term',
                        value: `${this.activeFacility.premium_payment_term} days`
                    },
                    {
                        text: 'Present Statement of Facts to client?',
                        value: (this.activeFacility.do_not_display_sof === 1 || this.activeFacility.do_not_display_sof === true) ? 'No' : 'Yes'
                    },
                    {
                        text: 'Inception date',
                        value: this.$moment(this.activeFacility.inception_date).format('DD/MM/YYYY')
                    },
                    {
                        text: 'End date',
                        value: this.$moment(this.activeFacility.end_date).format('DD/MM/YYYY')
                    }
                ]
            },
            producingBrokers() {
                return this.companies.filter(c => c.company_type === 'producing_broker');
            },
            insurers() {
                return this.companies.filter(c => c.company_type === 'insurer');
            },
            captiveInsurers() {
                return this.companies.filter(c => c.company_type === 'captive_insurer');
            },
            getWaitingPeriodInterestName() {
                let currentWpi = this.activeFacility.waiting_period_interest;
                let wpi = WaitingPeriodInterestOptions.find(function (option) {
                    return option.value == currentWpi;
                });
                return wpi.name;
            },
            waitingPeriods() {
                return this.$root.waitingPeriods ? this.$root.waitingPeriods : [];
            }
        },
        watch: {
            formattedFacilities(newFacilities) {
                this.pagination.totalItems = newFacilities.length;
            },
            pageCount(newPageCount) {
                if (this.pagination.page > newPageCount) {
                    this.pagination.page = 1;
                }
            },
        },
        created() {
            this.fetchData();
        },
        methods: {
            async fetchData() {

                this.companies = (await axios.get(this.$root.api('company'))).data.data;
                this.profile = this.$root.user;

                const mountRequests = [];

                mountRequests.push(axios.get(this.$root.api('facility')).then(res => {
                    this.facilities = res.data.data
                }));
                mountRequests.push(axios.get(this.$root.api('client')).then(res => {
                    this.clients = res.data.data
                }));
                mountRequests.push(axios.get(this.$root.api('product')).then(res => {
                    this.products = res.data.data
                }));
                mountRequests.push(axios.get(this.$root.api('broker/security')).then(res => {
                    this.securities = res.data.data
                }));

                axios.all(mountRequests).then(() => {
                    this.pageLoading = false;
                });
            },
            async submitFacility() {
                if (this.$refs.form.validate()) {
                    this.pageLoading = true;

                    try {
                        const data = this.editing
                            ? await this.updateFacility(this.activeFacility)
                            : await this.createFacility(this.activeFacility);

                        this.activeFacility = data;
                        this.facilities = (await axios.get(this.$root.api('facility'))).data.data;
                        this.showFacilitySummary = true;
                        this.closeFacilityForm();
                        this.pageLoading = false;

                    } catch (err) {
                        this.pageLoading = false;
                    }
                }
            },
            async createFacility (facility) {
                const { data } = await axios.post(this.$root.api('facility'), { ...facility });
                return data;
            },
            async updateFacility (facility) {
                const { data } = await axios.put(this.$root.api(`facility/${facility.id}`), { ...facility });
                return data;
            },
            goToDashboard() {
                this.$router.push({
                    name: 'broker-dashboard'
                });
            },
            addFacility() {
                this.activeFacility = { ...this.$options.data().activeFacility};
                this.editing = false;
                this.showFacilityForm = true;
            },
            editFacility(facility) {
                const activeFacility = {};
                activeFacility.id = facility.id;
                activeFacility.name = facility.name;
                activeFacility.UMR = facility.UMR;
                activeFacility.brokerage = facility.brokerage;
                activeFacility.inception_date = facility.inception_date;
                activeFacility.end_date = facility.end_date;
                activeFacility.producing_broker_id = this.getFacilityProducingBroker(facility).id;
                activeFacility.client_id = this.getFacilityClient(facility).id;
                activeFacility.insurer_ids = this.getFacilityInsurers(facility).map(c => c.id);
                activeFacility.captive_insurer_id = this.getFacilityCaptiveInsurer(facility).id;
                activeFacility.product_ids = facility.product_ids;
                activeFacility.security_ids = facility.security_ids;
                activeFacility.waiting_period_values = facility.waiting_period_values || [];
                activeFacility.waiting_period_interest = facility.waiting_period_interest;
                activeFacility.premium_payment_term = facility.premium_payment_term;
                activeFacility.entity_ids = facility.entity_ids;
                activeFacility.do_not_display_sof = facility.do_not_display_sof;
                activeFacility.status = facility.status;

                this.activeFacility = { ...activeFacility};
                this.editing = true;
                this.showFacilityForm = true;
            },
            getFacilityInsurers(facility) {
                return facility.companies.filter(c => c.company_type === 'insurer');
            },
            getFacilityCaptiveInsurer(facility) {
                return facility.companies.find(c => c.company_type === 'captive_insurer') || this.naCompany;
            },
            getFacilityClient(facility) {
                return facility.companies.find(c => c.company_type === 'client');
            },
            getFacilityProducingBroker(facility) {
                return facility.companies.find(c => c.company_type === 'producing_broker') || this.naCompany;
            },
            closeSummary() {
                this.showFacilitySummary = false;
                this.fetchData();
            },
            closeFacilityForm() {
                this.showFacilityForm = false;
            },
            getStatus(status) {
                return status === 1 ? "Active" : "Inactive";
            }
        }
    }
</script>

<style lang="scss" scoped>

    :deep(.x-table) {
        margin-top: 36px;
    }
</style>
